// ABOUTME: Utility functions for displaying user information in the Oracle app
// ABOUTME: Handles nickname fallback logic and email prefix extraction for user display names

/**
 * Gets the display name for a user
 * @param {Object} user - User object from PocketBase auth
 * @param {string} user.nickname - Optional nickname field
 * @param {string} user.email - User's email address
 * @returns {string} Display name (nickname, email prefix, or "Visitante" fallback)
 *
 * @example
 * getDisplayName({ nickname: "Maria", email: "maria@example.com" }) // Returns "Maria"
 * getDisplayName({ email: "test5@livia-bueno.com" }) // Returns "test5"
 * getDisplayName(null) // Returns "Visitante"
 */
export const getDisplayName = (user) => {
  // Handle null/undefined user
  if (!user) {
    return "Visitante";
  }

  // Return nickname if it exists and is not empty
  if (user.nickname && user.nickname.trim() !== '') {
    return user.nickname;
  }

  // Extract email prefix (before @)
  if (user.email && user.email.includes('@')) {
    return user.email.split('@')[0];
  }

  // Final fallback if email is invalid
  return "Visitante";
};
